import { Filial } from "../filial/filial";
import { Especialidade } from "./especialidade";
import { EspecialidadeFilialPk } from "./pks/especialidade-filial-pk";

export class EspecialidadeFilial {

    pk: EspecialidadeFilialPk = new EspecialidadeFilialPk();

    especialidade: Especialidade = new Especialidade();

    filial: Filial = new Filial();

    constructor() {
    }
}
